import { render, staticRenderFns } from "./EditStatementsModal.vue?vue&type=template&id=2068af79&"
import script from "./EditStatementsModal.vue?vue&type=script&lang=js&"
export * from "./EditStatementsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStatementsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports